module.exports = __webpack_public_path__ + "b376fb56f1.svg";